/**
 * Converts a documentation section path to URL segments (without language suffix).
 * e.g. "docs/how-to-guides/expose-code" → "how-to-guides/expose-code"
 */
export function documentationArticleUrlPath(sectionPath: string): string {
  return sectionPath.replace(/^docs\//, '').replace(/\.(md|mdx)$/i, '')
}
